// extracted by mini-css-extract-plugin
module.exports = {"layout":"JoinPage_layout__41_EJ","container":"JoinPage_container__wVBq1","modules":"JoinPage_modules__zdJeT"};